import { render, staticRenderFns } from "./confirmOrderList.vue?vue&type=template&id=4a7e9916&scoped=true&"
import script from "./confirmOrderList.vue?vue&type=script&lang=js&"
export * from "./confirmOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7e9916",
  null
  
)

export default component.exports